import * as React from "react";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { store } from "../../../store";
import { formSet, formSetValue, formTriggerValidation } from "../../gvc/testNewForm/utils";
import { FormListFieldItem } from "../../gvc/formListFieldItem";
import { IpSetLocation } from "../../../schema/types/ipset/input";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { IpSetLocationRetentionPolicyOptions } from "../../../mst/kinds/ipset.helpers";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";
import { Location } from "../../../schema/types/location/entity";

interface Props {
  name?: string;
  item?: IpSetLocation;
  index?: number;
}
export const CpArrayItemIpSetLocation: React.FC<Props> = React.memo(({ name: _name, item: _item, index: _index }) => {
  const { id } = useCpFormContext();

  const name = _name!;
  const item = _item!;
  const index = _index!;

  function remove() {
    const form = store.getState().form.instances[id];
    const values = form.values;
    const items = get(values, name) || [];
    let _items = cloneDeep(items);
    _items = _items.filter((i) => i.id !== item.id);
    formSetValue(id, name, _items);

    formTriggerValidation(id);
  }

  return (
    <FormListFieldItem columnCount={4} hasRemoveButton className="mb-1">
      <CpKindSelect
        className={"col-span-3"}
        style={{ width: `100%` }}
        name={`${name}.${index}.location`}
        kind="location"
        optionValue="name"
        filterOptionsFn={(item: Location) => item.spec?.enabled === true}
      />
      <CpSelect
        className={"col-span-1"}
        name={`${name}.${index}.retentionPolicy`}
        options={IpSetLocationRetentionPolicyOptions}
      />
      <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
    </FormListFieldItem>
  );
});
